import _ from "lodash";
import React, { useEffect, useState, useContext } from "react";
import StoreContext from "contexts/StoreContext";
import { Card, Table } from "react-bootstrap";
import { apiService } from "service/ApiService";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { formatDiagnosticsWithColorAndContext } from "typescript";
import { getModeNameByid } from "utils/AppUtils";
import { useTranslation } from "react-i18next";

Chart.register(ArcElement, Tooltip, Legend, ChartDataLabels);

export default function SalesPerMode() {
  const { t } = useTranslation();
  const { storeId, setStoreId } = useContext(StoreContext);
  const [modeData, setModeData] = useState([]);

  const getIncomes = () => {
    apiService
      .get(`api/v1/stores/${storeId}/mode-income`)
      .then((resp) => {
        formatData(resp);
      })
      .catch((error) => {
        console.error(error);
        setModeData([]);
      });
  };

  const formatData = (data) => {
    let total = _.sumBy(data, "total_income");
    data.map((el) => {
      el.percentage = ((el.total_income / total) * 100).toFixed(0);
    });

    setModeData(data);
  };
  useEffect(() => {
    if (!storeId) return;
    getIncomes();
  }, [storeId]);

  return (
    <>
      <Card className="strpied-tabled-with-hover">
        <Card.Header>
          <Card.Title as="h5">{t("dashboard.reports.salesByMode")}</Card.Title>
          <p className="card-category">{t("dashboard.reports.includesAdjustments")}</p>
        </Card.Header>
        <Card.Body className="table-responsive p-0">
          <Table className="table-hover table-striped w-full align-text-right">
            <tbody>
              {modeData.map((dt) => {
                return (
                  <tr key={dt.percentage}>
                    <td className="bold align-text-left">{getModeNameByid(dt.mode_id)}</td>
                    <td>{dt.orders}</td>
                    <td>{dt.total_income.toFixed(2)}</td>
                    <td>{dt.percentage}%</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </>
  );
}
